// extracted by mini-css-extract-plugin
module.exports = {"searchFilter":"SearchBar_searchFilter__2dGVB","search":"SearchBar_search__2OAPI","input":"SearchBar_input__2Emec"};